module.exports = __webpack_public_path__ + "img/reduced-absenteeism-impact.fd334b75.svg";